import { Outlet } from "react-router-dom";
import PublicFooter from "./PublicFooter";

const PublicLayout = () => (
  <>
    <Outlet />
    <PublicFooter />
  </>
);

export default PublicLayout;
